import { MouseEvent, useCallback, useEffect, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { useStarredEntities } from '@backstage/plugin-catalog-react';

type StarCheckboxProps = {
  name: string;
  namespace: string;
  kind: string;
  size?: {
    height: string;
    width: string;
  };
};

export const StarCheckbox = ({
  name,
  namespace,
  kind,
  size = { height: '42px', width: '42px' },
}: Readonly<StarCheckboxProps>) => {
  const { starredEntities, toggleStarredEntity } = useStarredEntities();
  const [currentEntity, setCurrentEntity] = useState<string>('');
  const [isStarred, setIsStarred] = useState<boolean>(false);

  const handleClick = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      toggleStarredEntity(currentEntity);
    },
    [currentEntity, toggleStarredEntity],
  );

  useEffect(() => {
    const entityRef = `${kind?.toLowerCase()}:${namespace ?? 'default'}/${name}`;
    const isEntityStarred = starredEntities.has(entityRef);
    setIsStarred(isEntityStarred);
    setCurrentEntity(entityRef);
  }, [kind, name, namespace, starredEntities]);

  return (
    <Checkbox
      sx={{ width: size.width, height: size.height }}
      icon={<StarBorderIcon />}
      checkedIcon={<StarIcon />}
      color="primary"
      data-testid="favourites-button"
      checked={isStarred}
      onClick={handleClick}
    />
  );
};
